// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__xHQOK","dark":"BaseLayout_dark__QmjV+","light":"BaseLayout_light__hgTsB"};